export enum ROUTE_NAMES {
  HOME = 'Home',
  // UI
  DASHBOARD = 'Dashboard',
  DOCS = 'Docs',
  PROFILE = 'Profile',
  LOGOUT = 'Logout',
  LOGIN = 'Login',
  ERROR = 'Error',
  ERROR_PAGE = 'Error Page',
  NOT_FOUND = 'Not Found',
  // Contacts
  CONTACTS = 'Contacts',
  CONTACT_CREATE = 'Create Contact',
  CONTACT_EDIT = 'Edit Contact',
  NOTIFICATION_SETTINGS = 'Notification Settings',
  // LOGS
  ACTIVITY_LOGS = 'Activity Logs',
  ACTIVITY_LOGS_LOCATION = 'Activity Logs Location',
  // ORG
  ORGANIZATIONS = 'Organizations',
  CREATE_ORGANIZATION = 'Create Organization',
  ORGANIZATION = 'Organization',
  EDIT_ORGANIZATION = 'Edit Organization',
  // LOCATIONS
  LOCATIONS = 'Locations',
  CREATE_LOCATION = 'Create Location',
  EDIT_LOCATION = 'Edit Location',
  // Location
  LOCATION = 'Location',
  LOCATION_GENERAL = 'Location General',
  LOCATION_LINES = 'Location Lines',
  LOCATION_DIAGNOSTICS = 'Location Diagnostics',
  LOCATION_EMERGENCY = 'Location Emergency',
  LOCATION_HARDWARE_CREATE = 'Location Create Hardware',
  LOCATION_HARDWARE_EDIT = 'Location Edit Hardware',
  LOCATION_KIT_EDIT = 'Location Edit Kit',
  LOCATION_MEDIA = 'Location Media',
  LOCATION_PERFORMANCE = 'Location Performance',
  // DIVISIONS
  DIVISIONS = 'Divisions',
  CREATE_DIVISION = 'Create Division',
  EDIT_DIVISION = 'Edit Division',
  DIVISION = 'Division',
  // LINES
  LINES = 'Lines',
  CDRS = 'CDRs',
  LINES_MANAGE = 'Manage Lines',
  LINES_CREATE = 'Create Lines',
  LINES_EDIT = 'Edit Lines',
  LINES_EDIT_USER = 'Edit Lines User',
  LINES_EMERYGENCY_ADDRESS = 'Lines Emergency Address',
  // IVR
  CREATE_IVR = 'Create IVR',
  EDIT_IVR = 'Edit IVR',
  // USERS
  USERS = 'Users',
  USER_CREATE = 'Invite User',
  USER_EDIT = 'Edit User',
  // HARDWARE
  HARDWARE = 'Hardware',
  BUNDLES = 'Bundles',
  BUNDLE_CREATE = 'Create Bundle',
  BUNDLE_EDIT = 'Edit Bundle',
  // Routers
  ROUTER_CATALOGS = 'Router Catalogs',
  ROUTER_CATALOG_CREATE = 'Router Catalogs Create',
  ROUTER_CATALOG_EDIT = 'Router Catalogs Edit',
  ROUTER_SIMS = 'Router SIMs',
  ROUTER_CREATE_SIMS = 'Router Create SIMs',
  ROUTER_EDIT_SIMS = 'Router Edit SIMs',
  // Gateways
  GATEWAY_CATALOGS = 'Gateways Catalogs',
  GATEWAY_CATALOG_CREATE = 'Gateways Catalogs Create',
  GATEWAY_CATALOG_EDIT = 'Gateways Catalogs Edit',
  // Power Sources
  POWERSOURCE_CATALOGS = 'Power Sources Catalogs',
  POWERSOURCE_CATALOG_CREATE = 'Power Sources Catalogs Create',
  POWERSOURCE_CATALOG_EDIT = 'Power Sources Catalogs Edit',
  // MISC
  TOOLS = 'Tools',
  DECOMMISSION = 'Decommission',
}

export enum TAB_ROUTES {
  GENERAL = 'general',
  LINES = 'lines',
  SERVICES = 'services',
  DIAGNOSTICS = 'diagnostics',
  EMERGENCY = 'emergency',
  CDRS = 'cdrs',
  PERFORMANCE = 'performance',
}

export enum ENTITY_ROUTES {
  GATEWAY = 'gateways',
  ROUTER = 'routers',
  POWERSOURCE = 'powersources',
  HYBRID = 'hybrids',
  LINES = 'lines',
  SIMS = 'sims',
}
